import {
  Autocomplete,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getActiveBusinessRelationsForUser } from '../../../../lib/api';
import {
  executeScraping,
  getScrapingStatus,
} from '../../../../lib/api/pruffRush';
import CustomButton from '../../../../lib/designSystem/Button';
import CenteredCircularProgress from '../../../../lib/designSystem/CircularProgress';
import EnhancedTable from '../../../../lib/designSystem/Table';
import {
  showAlert,
  validatePermissions,
} from '../../../../lib/functions/utils';
import { AuthState } from '../../../../services/redux/authSlice';

const NewEvaluation = (props: any) => {
  const { setOpen, open, setSuccessOpen, setFailureOpen, setUp } = props;
  const [loading, setLoading] = useState(false);
  const [businesses, setBusinesses] = useState<any>([]);
  const [business, setBusiness] = useState<any>(null);
  const dispatch = useDispatch();
  const [scrapingSelected, setScrapingSelected] = useState<any>(null);
  const [lastStateScraping, setLastStateScraping] = useState<any>([]);
  const user = useSelector((state: { auth: AuthState }) => state.auth.user);

  const validateAttributes = () => {
    return true;
  };

  const handleSubmit = async () => {
    if (!validateAttributes()) return;
    setLoading(true);
    try {
      await executeScraping(dispatch, scrapingSelected.scrapingId, business.id);
      setSuccessOpen(
        'Sincronización creada correctamente. Recuerda que podría demorar unos minutos en completarse.',
      );
      setOpen(false);
      await setUp();
    } catch (error: any) {
      if (error.response.data.message === 'Credenciales no válidas') {
        showAlert(
          dispatch,
          'error',
          'Las credenciales fueron rechazadas por el SII, esto quiere decir que el cliente pudo haberlas cambiado desde la última extracción.',
        );
        setLoading(false);
        return;
      }
      setFailureOpen('Ha ocurrido un error desconocido');
      setLoading(false);
    }
  };

  const activeScrapings = [
    ...(validatePermissions(user, 'pruffRush_execute_sii')
      ? [{ scrapingId: 'siiDocuments', scrapingName: 'Documentos SII' }]
      : []),
    { scrapingId: 'tgr', scrapingName: 'TGR' },
  ];

  const fetchAvailableBusinesses = async () => {
    setLoading(true);
    try {
      const businessesResponse =
        await getActiveBusinessRelationsForUser(dispatch);
      setBusinesses(businessesResponse);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  const handleSelectScraping = async (scrapingValue: any) => {
    const scraping = activeScrapings.find(
      (scraping) => scraping.scrapingId === scrapingValue,
    );
    if (!scraping) return;
    setScrapingSelected(scraping);
    setLoading(true);
    try {
      const lastStateScrapingResponse = await getScrapingStatus(
        dispatch,
        scraping.scrapingId,
        business.id,
      );
      setLastStateScraping(lastStateScrapingResponse);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchAvailableBusinesses();
  }, []);

  const handleChange = (event: any, newValue: any) => {
    setBusiness(newValue);
    setScrapingSelected(null);
    setLastStateScraping([]);
  };

  return (
    <Dialog maxWidth="md" open={open} onClose={() => setOpen(false)}>
      <DialogTitle>Nueva sincronización</DialogTitle>
      <DialogContent>
        {loading ? (
          <CenteredCircularProgress type="dialog" />
        ) : (
          <div>
            <Typography variant="body1" style={{ margin: '8px 0px' }}>
              A continuación selecciona la empresa
            </Typography>
            <Autocomplete
              options={businesses.relations}
              value={business}
              getOptionLabel={(option) =>
                `${option.businessName} - ${option.identifier}`
              }
              renderInput={(params) => (
                <TextField
                  style={{ minWidth: 250 }}
                  {...params}
                  label="Selecciona el cliente "
                />
              )}
              onChange={handleChange}
              fullWidth
            />
            {!business ? null : (
              <FormControl fullWidth margin="normal">
                <InputLabel id="filter-label">
                  Sincronización a realizar
                </InputLabel>
                <Select
                  labelId="filter-label"
                  label="Sincronización a realizar"
                  value={scrapingSelected?.scrapingId}
                  onChange={(e) => handleSelectScraping(e.target.value)}
                >
                  {activeScrapings.map((scraping: any) => (
                    <MenuItem key={scraping.id} value={scraping.scrapingId}>
                      {scraping.scrapingName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}

            {scrapingSelected ? (
              <div>
                {lastStateScraping.length > 0 ? (
                  <div>
                    <Typography variant="body1" style={{ margin: '8px 0px' }}>
                      Últimas sincronizaciones
                    </Typography>
                    <EnhancedTable
                      dataHeaders={[
                        { label: 'Nombre', key: 'name' },
                        {
                          label: 'Última sincronización',
                          key: 'status',
                          type: 'date-large',
                        },
                      ]}
                      rowsPerPageDefault={10}
                      data={lastStateScraping}
                    />
                  </div>
                ) : (
                  <div>
                    <Typography variant="body1" style={{ margin: '8px 0px' }}>
                      No se ha realizado ninguna sincronización
                    </Typography>
                  </div>
                )}
                <Typography
                  variant="body1"
                  color="warning"
                  style={{ margin: '8px 0px' }}
                >
                  Recuerda que la sincronización podría demorar unos minutos.
                </Typography>
              </div>
            ) : null}
          </div>
        )}
      </DialogContent>
      <DialogActions>
        <CustomButton color="secondary" onClick={() => setOpen(false)}>
          {' '}
          Cancelar{' '}
        </CustomButton>
        <CustomButton
          disabled={business === null || scrapingSelected === null || loading}
          color="primary"
          onClick={() => handleSubmit()}
        >
          {' '}
          Sincronizar
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default NewEvaluation;
